/* src/app/common/components/search-bar/search-bar.component.scss */
ion-searchbar {
  --padding-start: 8px;
  --padding-end: 8px;
  --background: white;
}
/*# sourceMappingURL=search-bar.component.css.map */
